var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGrid7(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 17,
    viewBox: "0 0 20 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 0.839966H2C0.9 0.839966 0.00999999 1.73997 0.00999999 2.83997L0 14.84C0 15.94 0.9 16.84 2 16.84H18C19.1 16.84 20 15.94 20 14.84V2.83997C20 1.73997 19.1 0.839966 18 0.839966ZM18 4.83997L10 9.83997L2 4.83997V2.83997L10 7.83997L18 2.83997V4.83997Z",
    fill: "white",
    fillOpacity: 0.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrid7);
export default __webpack_public_path__ + "static/media/grid7.92fcd699efbb4d359720f7de5cbe642d.svg";
export { ForwardRef as ReactComponent };